(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const categoryOf = value => {
    const label = normalize(value);
    if (label.includes('celular') || label.includes('capinha') || label.includes('pelicula')) return 'phone';
    if (label.includes('casa') || label.includes('cozinha') || label.includes('talher')) return 'home';
    if (label.includes('tecnologia') || label.includes('fone') || label.includes('carregador')) return 'tech';
    return label;
  };
  function setup(root) {
    if (root.dataset.ermenInitialized) return;
    root.dataset.ermenInitialized = 'true';
    const grid = root.querySelector('[data-ermen-grid]');
    const cards = [...root.querySelectorAll('[data-ermen-card]')];
    const buttons = [...root.querySelectorAll('[data-ermen-filter]')];
    const empty = root.querySelector('[data-ermen-empty]');
    const sort = root.querySelector('[data-ermen-sort]');
    const count = root.querySelector('[data-ermen-count]');
    let selected = 'all';
    if (!grid || !cards.length) return;
    root.querySelector('[data-ermen-controls]').hidden = false;
    function filter(value) {
      selected = ['all', 'tech', 'home', 'phone'].includes(value) ? value : 'all';
      for (const card of cards) card.hidden = selected !== 'all' && categoryOf(card.dataset.category) !== selected;
      for (const button of buttons) {
        const active = button.dataset.ermenFilter === selected;
        button.classList.toggle('em-active', active);
        button.setAttribute('aria-pressed', String(active));
      }
      empty.hidden = cards.some(card => !card.hidden);
      if (count) {
        const visible = cards.filter(card => !card.hidden).length;
        count.textContent = `${visible} ${root.dataset.preview === 'true' ? root.dataset.modelLabel : root.dataset.countLabel}`;
      }
    }
    buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.ermenFilter)));
    root.querySelector('[data-ermen-reset]').addEventListener('click', () => filter('all'));
    sort.addEventListener('change', () => {
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'price_low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price_high') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.position) - Number(b.dataset.position);
      });
      ordered.forEach(card => grid.append(card));
    });
    root.querySelectorAll('[data-ermen-category-link]').forEach(link => link.addEventListener('click', () => filter(link.dataset.ermenCategoryLink)));
    document.querySelectorAll('[data-ermen-nav]').forEach(link => link.addEventListener('click', event => {
      const url = new URL(link.href, window.location.href);
      if (!url.searchParams.has('ermen_category') || url.pathname !== window.location.pathname) return;
      event.preventDefault();
      filter(link.dataset.ermenNav);
      root.querySelector('#catalogo').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    filter(new URLSearchParams(location.search).get('ermen_category') || 'all');
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-ermen-storefront]').forEach(setup);
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const header = document.getElementById('header-group');
  if (header) {
    const measure = () => {
      const height = header.querySelector('.em-header')?.getBoundingClientRect().height || header.getBoundingClientRect().height;
      const announcement = header.querySelector('.em-announcement')?.getBoundingClientRect().height || 0;
      document.documentElement.style.setProperty('--ermen-header-height', `${height}px`);
      document.documentElement.style.setProperty('--ermen-announcement-height', `${announcement}px`);
      document.body.style.setProperty('--header-height', `${height}px`);
      document.body.style.setProperty('--header-group-height', `${height + announcement}px`);
    };
    measure();
    new ResizeObserver(measure).observe(header);
  }
})();
